import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';

/**
 * Zendesk SSO login route (DEV-11861).
 *
 * Public, top-level state at `/zendesk/login` (no auth guard), mirroring the
 * `login` splash layout. The view is rendered entirely by the downgraded
 * Angular component `<ng-zendesk-login>` (see
 * apps/b2b-frontend/app/features/zendesk-login).
 *
 * Zendesk redirects the unauthenticated user here with a `return_to` query
 * param (the deep link they were trying to reach). It is declared on the URL
 * so ui-router preserves it across the hybrid transition; the component reads
 * it and forwards it to Java, which validates it against the DB allowlist
 * before issuing the signed JWT.
 */
export const ZendeskLoginView = angular
  .module('acme.view.zendeskLogin', [uiRouter])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'zendeskLogin',
      url: '/zendesk/login?return_to',
      abstract: true,
      views: {
        main: {
          templateUrl: 'layouts/standard.tpl.html',
        },
      },
      data: {
        pageClass: 'application-splash',
        pageTitle: 'Zendesk Sign In',
      },
    });

    $stateProvider.state({
      name: 'zendeskLogin.default',
      url: '',
      views: {
        'subview-main': {
          template: '<ng-zendesk-login></ng-zendesk-login>',
        },
      },
    });
  }).name;
